import { Component, Input, OnInit } from '@angular/core';
import { IUITKSelectItemProps } from '@uitk/angular';
import { ConfigService } from '../../services/config.service';
import { OrderService } from '../../services/order.service';

@Component({
  selector: 'app-quote-reason',
  templateUrl: './quote-reason.component.html',
  styleUrls: ['./quote-reason.component.css']
})
export class QuoteReasonComponent implements OnInit {
  @Input() dialog = { show: false };
  quoteReasons: IUITKSelectItemProps[] = [];
  quoteReason: IUITKSelectItemProps | null = null;

  constructor(
    private readonly configService: ConfigService,
    private readonly orderService: OrderService
  ) { }

  ngOnInit(): void {
    this.quoteReasons = this.configService.getPickList('QREASON');
  }

  ok() {
    this.orderService.orderDto.orderType = 'Q';
    this.orderService.orderDto.quoteReasonCode = this.quoteReason?.value ?? null;
    this.orderService.recalculateFields(this.orderService.orderDto);
    this.dialog.show = false;
  }

  cancel() {
    this.orderService.orderDto.orderType = ' ';
    this.orderService.recalculateFields(this.orderService.orderDto);
    this.dialog.show = false;
  }
}
